<template>
  <div class="callme_total_wrap hidden-xs-only">
<!--    <div class="callme_top_wrap"></div>-->
    <div class="callme_bottom_wrap">
      <div class="bottom_container">
<!--        <div class="items_wrap">-->
<!--          <div class="item_tit">产品</div>-->
<!--          <div class="item_options">-->
<!--            <span @click="handleToRouter('/production/1')">产业大脑</span>-->
<!--            <span @click="handleToRouter('/production/2')">云招商</span>-->
<!--            <span @click="handleToRouter('/production/3')">企业创新服务</span>-->
<!--            <span @click="handleToRouter('/production/4')">企业咨询</span>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="items_wrap">-->
<!--          <div class="item_tit">内容中心</div>-->
<!--          <div class="item_options">-->
<!--            <span @click="handleToRouter('/fournav/1')">行业报告</span>-->
<!--            <span @click="handleToRouter('/fournav/2')">精选文章</span>-->
<!--            <span @click="handleToRouter('/fournav/3')">媒体报道</span>-->
<!--          </div>-->
<!--        </div>-->
        <div class="items_wrap">
          <div class="item_tit">联系我们</div>
          <span class="item_desc " ><div class="el-icon-location-information item_desc_icon "></div><div>深圳总部：龙岗区中安大厦9楼915</div></span>
          <span class="item_desc " ><div class="el-icon-location-information item_desc_icon "></div><div>联系方式：13242041687</div></span>
<!--          <span class="item_desc " ><div class="el-icon-location-information item_desc_icon "></div><div>邮箱： </div></span>-->
<!--          <div class="item_options">-->
<!--            <el-menu-->
<!--              :default-active="activeIndex"-->
<!--              class="el_menu_demo"-->
<!--              mode="horizontal"-->
<!--              background-color="#21282D"-->
<!--              text-color="#8F9095"-->
<!--              active-text-color="#8F9095"-->
<!--              @select="handleSelect"-->
<!--            >-->
<!--              <el-menu-item index="1" class="el_menu_item">杭州</el-menu-item>-->
<!--              <el-menu-item index="2" class="el_menu_item">成都</el-menu-item>-->
<!--              <el-menu-item index="3" class="el_menu_item">北京</el-menu-item>-->
<!--              <el-menu-item index="4" class="el_menu_item">重庆</el-menu-item>-->
<!--            </el-menu>-->
<!--            <div class="massage_show">-->
<!--              <p>{{ cityInfomation[showCity].phone }}</p>-->
<!--              <p>{{ cityInfomation[showCity].eamil }}</p>-->
<!--              <p>{{ cityInfomation[showCity].address }}</p>-->
<!--            </div>-->
<!--          </div>-->
        </div>
<!--        <div class="items_wrap hidden-md-and-down" style="margin-left: 120px">-->
<!--          <div class="item_tit">关注我们</div>-->
<!--          <div class="item_options">-->
<!--            <img src="@/assets/img/guanzhu.png" alt="" />-->
<!--            <span style="text-align: center; margin-top: 15px"-->
<!--              >云逸产业大脑...</span-->
<!--            >-->
<!--          </div>-->
<!--        </div>-->
        <div class="items_wrap hidden-md-and-down">
          <div class="item_tit">关注我们</div>
          <div class="item_options">
            <img src="@/assets/img/qrcode_for_whc.jpg" alt="" />
            <span style="text-align: center; margin-top: 15px"
              >文汇昌教育...</span
            >
          </div>
        </div>
      </div>
      <div class="navigate_wrap">

        <p>
          ICP备案号：<a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2026078831号-1</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '1',
      cityInfomation: [
        {
          phone: '0571-86885326',
          eamil: 'Contact@hsmap.com',
          address: '浙江省杭州市滨江区阡陌路482号智慧e谷B座7楼',
        },
        {
          phone: '028-86713133',
          eamil: 'Contact@hsmap.com',
          address: '成都市高新区天晖路360号晶科一号1806室',
        },
        {
          phone: '0571-86885326（转）',
          eamil: 'Contact@hsmap.com',
          address: '北京市朝阳区安翔北里11号院北京创业大厦B座1005',
        },
        {
          phone: '15051586330',
          eamil: 'Contact@hsmap.com',
          address: '重庆市九龙坡区华岩镇华锦路26号',
        },
      ],
      showCity: 0,
    }
  },
  methods: {
    handleSelect(index) {
      this.showCity = parseInt(index) - 1
    },
    handleToRouter(url) {
      this.$router.replace(url)
    },
  },
}
</script>

<style lang="scss" scoped>
.callme_total_wrap {
  width: 100%;
  margin-top: 80px;
  .callme_top_wrap {
    width: 100%;
    height: 300px;
    background: url('../../assets/img/call.a455486.png') 0 0 no-repeat;
    background-size: 100% 100%;
  }
  .callme_bottom_wrap {
    width: 100%;
    background: #21282d;
    color: #fff;
    padding-top: 70px;
    .bottom_container {
      width: 70%;
      margin: 0 auto;
      display: flex;
      padding-bottom: 60px;
      border-bottom: solid #363636 2px;
      .items_wrap {
        margin-right: 100px;
        .item_tit {
          font-size: 22px;
        }
        .item_options {
          display: flex;
          flex-direction: column;
          width: 120px;
          span {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 16px;
            margin-top: 35px;
            cursor: pointer;
            &:hover {
              font-weight: bold;
            }
          }
          .el_menu_demo {
            border: none;
            background: none;
            margin-top: 10px;
            width: 300PX;
            .el_menu_item {
              &:hover {
                font-weight: bold;
              }
            }
          }
          .massage_show {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 15px;
            width: 300PX;
            height: 80px;
            p {
              margin-top: 30px;
            }
          }
          img {
            width: 100%;
            margin-top: 20px;
          }
        }
        .item_desc {
          display: flex;
          flex-direction: row;
          margin-top: 20px;
          color: hsla(0, 0%, 100%, 0.5);
          font-size: 16px;
          width: 350px;
          .item_desc_icon {
            font-size:35px;
            margin-right: 10px;
            margin-top: 5px;
          }

        }
      }
    }
    .navigate_wrap {
      width: 70%;
      margin: 0 auto;
      margin-top: 40px;
      padding-bottom: 15px;
      // word-break: keep-all;
      // word-wrap: break-word;
      text-align: center;
      display: flex;
      flex-wrap: wrap;
      a {
        color: hsla(0, 0%, 100%, 0.5);
        font-size: 16px;
        margin-right: 33px;
        text-decoration: none;
      }
      span {
        color: #fff;
        padding-right: 30px;
        font-size: 18px;
        margin-right: 0;
      }
      p {
        font-size: 16px;
        color: #4e5557;
      }
    }
  }
}
</style>